import {  gql } from 'apollo-angular';
export const MUTATIONS  = {
    login: gql `
      mutation login($data:LoginInput!) {
        login(data: $data) {
          accessToken
          refreshToken
          userId
          rol
          temporalToken
          subscriptionId
        }
      }
    `,
    loginWithToken : gql`
      mutation loginWithToken($token:UUID!, $rol:Rol){
        loginWithToken(token:$token, rol:$rol){
          accessToken
          refreshToken
          temporalToken
          userId
          rol
          subscriptionId
        }
      }
    `,
    signUp: gql `
      mutation signUp($data:SignUpInput!){
        signUp(data:$data)
      }
    `,
    validateEmail: gql `
      mutation validateEmail ($token: UUID!) {
        validateEmail(token: $token)
      }
    `,
    refreshToken: gql `
      mutation refreshToken ($refreshToken:String!) {
        refreshToken( refreshToken: $refreshToken) {
          accessToken
          refreshToken
          temporalToken
          userId
          rol
        }
      }
    `,
    passwordRecover: gql `
      mutation passwordRecovery ($data:EmailInput!){
        passwordRecovery(data: $data)
      }
    `,
    passwordReset: gql `
      mutation passwordReset ($data:PasswordResetInput!){
        passwordReset( data: $data )
      }
    `,
    activatePassword: gql `
      mutation activatedPassword($data:PasswordInput!){
        activatePassword(data:$data)
      }
    `,
    updatePassword: gql `
      mutation updatePassword ($data: UpdatePasswordInput!) {
        updatePassword(data: $data)
      }
    `,
}
